import { render, staticRenderFns } from "./ReplyTarifa.vue?vue&type=template&id=145cc65f&scoped=true"
import script from "./ReplyTarifa.vue?vue&type=script&lang=js"
export * from "./ReplyTarifa.vue?vue&type=script&lang=js"
import style0 from "./ReplyTarifa.vue?vue&type=style&index=0&id=145cc65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cc65f",
  null
  
)

export default component.exports